module.exports = __webpack_public_path__ + "media/images/athletes/3554-499143f111bd0dac775fbc68d043d730.png";